import {
  LessonsStepDefinition,
  PracticeStepDefinition,
  stepTypes,
} from "../components/Lessons/Lesson/stepsDefinition";

import {
  getStudentProgress,
  getModuleById,
  getModuleProgress,
  getLessonsById,
  getLessonProgress,
  getLessonProgressById,
} from "@/api/api";
import studentMixin from "./studentMixin";

export default {
  mixins: [studentMixin],
  data() {
    return {
      progress: null,
      loadingResume: false,
    };
  },
  methods: {
    async getProgress() {
      try {
        const response = await getStudentProgress(this.student.uuid);
        this.progress = response.data;
      } catch {
        this.progress = null;
      }
    },
    async onResumeWork() {
      try {
        this.loadingResume = true;
        const { data: moduleResponse } = await getModuleById(this.progress.module);
        const progressResponse = await getModuleProgress({
          module__uuid: moduleResponse.uuid,
          student__email: this.student.email,
        });
        const moduleProgress = progressResponse.data.results[0];

        const { data: lessonResponse } = await getLessonsById(this.progress.lesson);
        const lessonProgress = await getLessonProgress({
          student__email: this.student.email,
          lesson__uuid: lessonResponse.uuid,
        });
        const { data: lessonProgressByUuid } = await getLessonProgressById(
          lessonProgress.data.results[0]?.uuid,
        );

        this.$store.commit("modules/selectedModule", moduleResponse);
        this.$store.commit("progress/module", moduleProgress);

        this.$store.commit("modules/currentLesson", lessonResponse);
        this.$store.commit("progress/lesson", lessonProgressByUuid);

        await this.$store.dispatch("lesson/teacher_lesson", lessonResponse.teacher_lesson);
        await this.$store.dispatch("lesson/practice", lessonResponse.practice);
        await this.$store.dispatch("lesson/grammar", lessonResponse.grammar);

        const stepDefinition = stepTypes.find((step) => step.value === this.progress.step_type);
        let index = 1;
        let route = { name: "lesson-view" };

        switch (stepDefinition.key) {
          case "TEACH_INTRO":
            return this.$router.push({ name: "introduction" });
          case "GRAMMAR_EXERCISE":
            return this.$router.push({
              name: "exercise",
              params: { index: this.progress.step_number },
            });
          default:
            switch (stepDefinition.section) {
              case "TEACHER_LESSON":
                index = LessonsStepDefinition.indexOf(stepDefinition.key);
                route = {
                  name: "guided-lesson",
                };
                if (stepDefinition.key === "Speaking") {
                  route.query = { sn: this.progress.step_number };
                } else if (stepDefinition.key === "Grammar") {
                  if (this.progress.step_number >= 0) {
                    route.query = { gn: this.progress.step_number };
                  }
                } else if (stepDefinition.key === "Homework") {
                  route.query = { hn: this.progress.step_number };
                }
                break;
              case "PRACTICE":
                index = PracticeStepDefinition.indexOf(stepDefinition.key);
                route = {
                  name: "practice",
                };
                if (stepDefinition.key === "Speaking") {
                  route.query = { sn: this.progress.step_number };
                } else if (stepDefinition.key === "Homework") {
                  route.query = { hn: this.progress.step_number };
                }
                break;
              default:
                break;
            }
            this.$store.commit("lesson/step", index);
            return this.$router.push(route);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingResume = false;
      }
    },
  },
};
